"use client";
import React, { useEffect, useState } from "react";
import { WhatsAppIcon } from "../../../public/Theme";
import Link from "next/link";
import {
    WHATSAPP_HUBSPOT,
    WHATSAPP_ICON_CLASS,
    WHATSAPP_IMAGE_CLASS,
    WHATSAPP_SLEEK_FLOW,
    WHATSAPP_URL,
} from "./constants";
import Image from "next/image";
import GTMLink from "../GTMLink";
import { GoogleTagManagerEvents } from "../../../common";

const Whatsapp = ({ userData }) => {
    const [whatsappNumber, setWhatsappNumber] = useState(
        WHATSAPP_URL + WHATSAPP_HUBSPOT
    );

    useEffect(() => {
        if (userData && userData?.payment_status === "paid") {
            setWhatsappNumber(WHATSAPP_URL + WHATSAPP_SLEEK_FLOW);
        } else setWhatsappNumber(WHATSAPP_URL + WHATSAPP_HUBSPOT);
    }, [userData]);
    return (
        <>
            <GTMLink
                external={true}
                event={GoogleTagManagerEvents.navigationInteractions}
                menuName={"Whatapp ChatBot"}
                place={"Whatsapp ChatBot"}
                className={WHATSAPP_ICON_CLASS}
                href={whatsappNumber}
                target="_blank"
                rel="noreferrer"
                alt="Message us"
                prefetch
            >
                <Image
                    width={30}
                    height={30}
                    src={WhatsAppIcon}
                    className={WHATSAPP_IMAGE_CLASS}
                    alt="Message us"
                />
            </GTMLink>
        </>
    );
};

export default Whatsapp;
